/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './breadcrumb.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/common';
import * as i5 from '../../../../app/header/breadcrumb/breadcrumb.component';
import * as i6 from '../../../../app/header/breadcrumb/breadcrumb.service';
const styles_BreadcrumbComponent:any[] = [i0.styles];
export const RenderType_BreadcrumbComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_BreadcrumbComponent,data:{}});
function View_BreadcrumbComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'h1',[['class',
      'font-size-l']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(1,(null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.breadcrumb.name;
    _ck(_v,1,0,currVal_0);
  });
}
function View_BreadcrumbComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'h1',[['class',
      'font-size-l']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(1,(null as any),['',''])),i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,
          i1.ChangeDetectorRef])],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵunv(_v,1,0,i1.ɵnov(_v,2).transform(_co.breadcrumb.name));
    _ck(_v,1,0,currVal_0);
  });
}
export function View_BreadcrumbComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),13,'div',[['class',
      'xtra-space container-fluid']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),10,'div',[['class','container']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n        '])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),
      7,'div',[['class','breadCrumb']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_BreadcrumbComponent_1)),i1.ɵdid(7,
      16384,(null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BreadcrumbComponent_2)),
      i1.ɵdid(10,16384,(null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i5.BreadcrumbComponent = _v.component;
    const currVal_0:boolean = !_co.isValid;
    _ck(_v,7,0,currVal_0);
    const currVal_1:any = _co.isValid;
    _ck(_v,10,0,currVal_1);
  },(null as any));
}
export function View_BreadcrumbComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-breadcrumb',
      ([] as any[]),(null as any),(null as any),(null as any),View_BreadcrumbComponent_0,
      RenderType_BreadcrumbComponent)),i1.ɵdid(1,114688,(null as any),0,i5.BreadcrumbComponent,
      [i6.BreadcrumbService,i3.TranslateService],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const BreadcrumbComponentNgFactory:i1.ComponentFactory<i5.BreadcrumbComponent> = i1.ɵccf('app-breadcrumb',
    i5.BreadcrumbComponent,View_BreadcrumbComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvaGVhZGVyL2JyZWFkY3J1bWIvYnJlYWRjcnVtYi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvc2hhaXphci9Qcm9qZWN0cy9NQU1QVS9NeUdvdi9wb3J0YWwtZmUvc3JjL2FwcC9oZWFkZXIvYnJlYWRjcnVtYi9icmVhZGNydW1iLmNvbXBvbmVudC50cyIsIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvaGVhZGVyL2JyZWFkY3J1bWIvYnJlYWRjcnVtYi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvaGVhZGVyL2JyZWFkY3J1bWIvYnJlYWRjcnVtYi5jb21wb25lbnQudHMuQnJlYWRjcnVtYkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJ4dHJhLXNwYWNlIGNvbnRhaW5lci1mbHVpZFwiPlxuICAgIDxkaXYgY2xhc3M9XCJjb250YWluZXJcIj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImJyZWFkQ3J1bWJcIj5cbiAgICAgICAgPGgxIGNsYXNzPVwiZm9udC1zaXplLWxcIiAqbmdJZj1cIiFpc1ZhbGlkXCI+e3ticmVhZGNydW1iLm5hbWV9fTwvaDE+XG4gICAgICAgIDxoMSBjbGFzcz1cImZvbnQtc2l6ZS1sXCIgKm5nSWY9XCJpc1ZhbGlkXCI+e3ticmVhZGNydW1iLm5hbWUgfCB0cmFuc2xhdGV9fTwvaDE+XG4gICAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuPC9kaXY+IiwiPGFwcC1icmVhZGNydW1iPjwvYXBwLWJyZWFkY3J1bWI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNHUTtNQUFBO01BQXlDOztJQUFBO0lBQUE7Ozs7b0JBQ3pDO01BQUE7TUFBd0M7OEJBQUE7O0lBQUE7SUFBQTs7OztvQkFKaEQ7TUFBQTtNQUFBLGdCQUF3Qyw4Q0FDcEM7TUFBQTtNQUFBLDBEQUF1QjtNQUFBLCtCQUNuQjtNQUFBO01BQUEsZ0JBQXdCLGtEQUN4QjtNQUFBLGdGQUFBO01BQUE7VUFBQSx3QkFBaUU7TUFDakU7YUFBQTtVQUFBLGlDQUE0RTtNQUN0RSw4Q0FDSjtVQUFBOztJQUhzQjtJQUF4QixXQUF3QixTQUF4QjtJQUN3QjtJQUF4QixZQUF3QixTQUF4Qjs7OztvQkNKUjtNQUFBO29DQUFBLFVBQUE7TUFBQTs7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/header/breadcrumb/breadcrumb.component.ngfactory.ts